module.exports = __webpack_public_path__ + "static/WpK_salon_pakiet_platynowy-14ff60c186d36350a8b23abbaa7ba4b3.jpg";